import { createReducer, createTypes } from 'reduxsauce';

export const eventoTypes = createTypes(
  `
      SET_QUANTIDADE_EVENTOS
      SET_EVENTOS
      ADD_EVENTO
      SET_ALARME
      SET_FETCH_ERROR
    `,
  { prefix: 'EVENTOS/' }
);

const INITIAL_STATE = {
  quantidade: {
    total: 0,
    alarmes: 0,
    bloqueios: 0,
    trips: 0,
  },
  eventos: [],
  fetchError: null,
};

const setEventos = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    quantidade: {
      ...state.quantidade,
      ...action.quantidade,
    },
    eventos: action.eventos,
  };
};

const setQuantidade = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    quantidade: {
      ...state.quantidade,
      ...action.quantidade,
    },
  };
};

const addEvento = (state = INITIAL_STATE) => {
  return {
    ...state,
    quantidade: {
      ...state.quantidade,
      total: state.quantidade.total + 1,
    },
  };
};

const setAlarme = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    alarme: action.alarme,
  };
};

const setFetchError = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    fetchError: action.error || null,
  };
};

export default createReducer(INITIAL_STATE, {
  [eventoTypes.ADD_EVENTO]: addEvento,
  [eventoTypes.SET_QUANTIDADE_EVENTOS]: setQuantidade,
  [eventoTypes.SET_ALARME]: setAlarme,
  [eventoTypes.SET_EVENTOS]: setEventos,
  [eventoTypes.SET_FETCH_ERROR]: setFetchError,
});
